import GradientCalculatorTable from './GradientCalculatorTable';

export default GradientCalculatorTable;
